import React from "react";
import PropTypes from "prop-types";
import Section from "../common/Section";
import Row from "../common/Row";
import ValidationStatusList from "./ValidationStatusList";
import Button from "../common/Button";
import Form from "../common/Form";
import Fieldset from "../common/Fieldset";
import classnames from 'classnames';
import * as types from "../../constants/ComponentConstants";
import moment from "moment";
import DownloadUploadFile from "../common/DownloadUploadFiles";

const IndienenForm = ({ indienen, disabled, onSave, color, pdf, isPollingDocument, generatePdf }) => {
    let itemsFrontendList = [];

    let wijktTotaleFinancieringAfVanTotaleInvestering = false;
    if (indienen.wijktTotaleFinancieringAfVanTotaleInvestering != null) {
        wijktTotaleFinancieringAfVanTotaleInvestering = indienen.wijktTotaleFinancieringAfVanTotaleInvestering;
    }

    let isTotaalKostenOpbrengstenNegatief = false;
    if (indienen.isTotaalKostenOpbrengstenNegatief != null) {
        isTotaalKostenOpbrengstenNegatief = indienen.isTotaalKostenOpbrengstenNegatief;
    }

    let isTotaalBedrijfskostenOfOpbrengstenNull = false;
    if (indienen.isTotaalBedrijfskostenOfOpbrengstenNull != null) {
        isTotaalBedrijfskostenOfOpbrengstenNull = indienen.isTotaalBedrijfskostenOfOpbrengstenNull;
    }

    let isMinimaalSportgerelateerdeInvesteringNietGehaald = false;
    if (indienen.isMinimaalSportgerelateerdeInvesteringNietGehaald != null) {
        isMinimaalSportgerelateerdeInvesteringNietGehaald = indienen.isMinimaalSportgerelateerdeInvesteringNietGehaald;
    }

    if (wijktTotaleFinancieringAfVanTotaleInvestering) {
        itemsFrontendList.push(
            {
                text: 'Je kan niet indienen gezien er geen 100% financiering van het project werd aangetoond rekening houdend met een eventuele minimale subsidie.',
                url: '/financieel/' + indienen.dossierId + "/financiering"
            }
        );
    }

    if (isTotaalKostenOpbrengstenNegatief) {
        itemsFrontendList.push(
            {
                text: 'Je kan niet indienen met een negatief verschil tussen de opbrengsten en kosten over een periode van 10 jaar van het project bij het criterium “financiële duurzaamheid”.',
                url: '/financieel/' + indienen.dossierId
            }
        );
    }

    if (isTotaalBedrijfskostenOfOpbrengstenNull) {
        itemsFrontendList.push(
            {
                text: 'Je kan niet indienen zonder een inschatting te maken van bedrijfsopbrengsten en bedrijfskosten.',
                url: '/financieel/' + indienen.dossierId
            }
        );
    }

    if (isMinimaalSportgerelateerdeInvesteringNietGehaald) {
        itemsFrontendList.push(
            {
                text: `Je kan niet indienen als het totaal van de sportgerelateerde investeringen (Excl BTW) van je project minder is dan €${indienen.minSportgerelateerdeInvesteringenExclBtw.toLocaleString(
                    undefined,
                    { minimumFractionDigits: 0 }
                )}.`,
                url: '/financieel/' + indienen.dossierId
            }
        );
    }

    if (indienen.infrastructurenZonderInvestering && indienen.infrastructurenZonderInvestering.length) {
        itemsFrontendList.push(
            {
                text: 'Er zijn geen investeringen opgegeven voor infrastructuur ' + indienen.infrastructurenZonderInvestering.join(', '),
                url: '/financieel/' + indienen.dossierId
            }
        );
    }

    const heeftWarnings = disabled || indienen.nrOfWarnings > 0 || wijktTotaleFinancieringAfVanTotaleInvestering || itemsFrontendList.length > 0;
    const indienenIsDisabled = heeftWarnings || indienen.isIndiendatumVerstreken || wijktTotaleFinancieringAfVanTotaleInvestering;
    const uitersteDatumIndienen = indienen.uitersteDatumIndienen ? moment(indienen.uitersteDatumIndienen).format("DD-MM-YYYY") : null;

    return (<Section title="Dien in" color={color}>
        <Form
            title="Bevestigingsformulier"
            name="indienen"
            rightButtonLabel="Dien in"
            onRightButtonClick={onSave}
            rightButtonDisabled={indienenIsDisabled}
            isNotRequired>
            <Fieldset>
                <p>Controleer goed of je het aanvraagformulier correct hebt ingevuld.</p>
                <p>Wanneer je je dossier hebt ingediend, kan je geen wijzigingen meer aanbrengen!</p>
                <p>Nadat je op "Dien in" drukt, zal er een mail met een PDF van jouw aanvraag verstuurd worden naar de 2 contactpersonen van het dossier.</p>
                <p>Opgelet: zorg er voor dat alle noodzakelijke bijlagen zijn toegevoegd.</p>
                <br />
                <p>Je kan dossiers indienen tot en met {uitersteDatumIndienen}</p>
                <br />
                <Row>
                    <div style={{ color: 'orange' }}>
                        <div className="o-col-1" style={{ textAlign: 'center' }}>
                            <i className={"fa " + classnames(types.FONT_ICON_EXCLAMATION)} style={{ fontSize: '2em' }}/>{'   '}
                        </div>
                        <div className="o-col-11">
                            <span style={{ fontSize: '.875rem', color: 'orange' }}>Jouw dossier is pas definitief ingediend als de voormelde (afgedrukte) PDF versie - met de nodige handtekeningen – tijdig is overhandigd op het hoofdkantoor van Sport Vlaanderen te Brussel (Arenbergstraat 5).</span>
                        </div>
                    </div>
                </Row>
                <br />
                {heeftWarnings || itemsFrontendList.length > 0 ? <p style={{ color: 'red' }}>Het dossier is nog niet klaar om ingediend te worden.</p> : ""}
                <br />
                {heeftWarnings || itemsFrontendList.length > 0 ? <ValidationStatusList items={indienen.validatieStatussen} itemsFrontend={itemsFrontendList} dossierType={indienen.typeDossier} /> : ""}
            </Fieldset>

            <Fieldset>
                <Row>
                    {indienen.dossierPDFGegenereerd ?
                        <DownloadUploadFile
                            dossierId={indienen.dossierId}
                            title="PDF van de subsidieaanvraag"
                            size={6}
                            tab=""
                            component=""
                            files={isPollingDocument ? [] : pdf.files}
                            color={color}
                            downloadOnly
                            isPdf /> : ""}

                    <div className="o-col-6" style={{ paddingTop: '15px' }}>
                        {isPollingDocument ? <p>Even geduld a.u.b.</p> : ""}
                        <Button onClick={generatePdf} disabled={isPollingDocument || disabled}>Genereer PDF</Button>
                    </div>
                </Row>
                <Row>
                    {indienen.datumDossierPDFGeneratie ? <p>Documenten gegenereerd op: {moment(indienen.datumDossierPDFGeneratie).format("DD-MM-YYYY HH:mm")}</p> : ""}
                </Row>
            </Fieldset>
        </Form>
    </Section>);
};

IndienenForm.propTypes = {
    onSave: PropTypes.func,
    indienen: PropTypes.object.isRequired,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    pdf: PropTypes.object,
    isPollingDocument: PropTypes.bool,
    generatePdf: PropTypes.func
};

export default IndienenForm;